import React, { useState, useEffect, useMemo } from "react";
import { Navigate } from "react-router-dom";
import { useSupaContext } from "../contexts/SupaContext";
import LoadingScreen from "../componets/ui/LoadingScreen";

const PrivateRoute = ({ children }) => {
  const {
    user,             // Este es combinedUser { ...userAuth, userData }
    isActiveUser,
    authInitialized, // Renombrado desde 'initialized' en SupaContext
    loading          // Este es ahora 'loading || userDataLoading' desde useAuthManager
  } = useSupaContext();

  const [renderState, setRenderState] = useState("pending"); // pending | authorized | unauthorized

  // Memoizar los estados para evitar cambios innecesarios
  const authState = useMemo(() => ({
    userId: user?.id,
    userDataId: user?.userData?.id,
    isActiveUser,
    authInitialized,
    loading,
  }), [user?.id, user?.userData?.id, isActiveUser, authInitialized, loading]);

  useEffect(() => {
    // Si la inicialización de Auth no ha terminado O si algo está cargando (Auth o Datos de Usuario)
    // Mantenemos el estado pendiente.
    if (!authState.authInitialized || authState.loading) {
      // Solo actualiza si el estado es diferente para evitar bucles
      if (renderState !== "pending") {
        setRenderState("pending");
      }
      return;
    }

    // Si la inicialización terminó y no hay carga pendiente:
    // Verificar si hay un usuario activo
    if (authState.userId && authState.isActiveUser) {
      // Solo actualiza si el estado es diferente
      if (renderState !== "authorized") {
        setRenderState("authorized");
      }
      return;
    }

    // Si la inicialización terminó, no hay carga, pero no hay usuario activo
    // Solo actualiza si el estado es diferente
    if (renderState !== "unauthorized") {
      setRenderState("unauthorized");
    }

  }, [authState, renderState]); // Usar authState memoizado y incluir renderState para evitar bucles

  // Memoizar los componentes de retorno para evitar recreación
  const loadingComponent = useMemo(() => 
    <LoadingScreen message="Verificando sesión..." />, 
    []
  );

  const redirectComponent = useMemo(() => 
    <Navigate to="/ingresar" replace />, 
    []
  );

  // Renderizar según el estado
  if (renderState === "pending") {
     return loadingComponent;
  }

  if (renderState === "unauthorized") {
    return redirectComponent;
  }

  // (renderState === "authorized")
  return children;
};

export default PrivateRoute;